import { Picture } from 'ui-kit/picture'
import { LandingIDEDataType } from './landingIDEData'
import classes from './LandingIDE.module.scss'

export const LandingIDECard = ({ card }: { card?: LandingIDEDataType }) => {
  if (!card) {
    return null
  }

  const { title, image1x, image2x } = card

  return (
    <div className={classes.card}>
      <Picture
        className={classes.card_image}
        src1x={image1x.src}
        src2x={image2x.src}
        noBreakpoint={true}
        alt={title}
        fetchPriorityHigh
      />
    </div>
  )
}
